/**
 * æ§ä»¶modelå¼å±æ§æä¸¾
 *
 * @export
 * @enum {number}
 */
export enum ControlModelPropertyEnum {
  /**
   * éé¡¹
   *
   */
  Option = 'option',
  /**
   * å³èå®ä½
   */
  AssociatedEntities = 'associatedEntities',
  /**
   * å³èå±æ§
   */
  AssociatedEntityAttributes = 'associatedEntityAttributes',
  /**
   * å³èå±æ§
   * æ­¤å±æ§å¯è½ä¼å¨æªæ¥æä¸ªçæ¬ç§»é¤ï¼ç®åæ¯ä¸ºäºå¼å®¹1.3.5ä¹åççæ¬
   */
  EntityAttribute = 'entityAttribute',

  /**
   * æ§ä»¶å¼
   */
  Value = 'value',

  /**
   * æ§ä»¶é»è®¤å¼
   */
  DefaultValue = 'defaultValue',

  /**
   * æ·»å æé®æå­
   */
  AddButtonText = 'addButtonText',

  /**
   * å é¤æé®é®é¢
   */
  DeleteButtonText = 'deleteButtonText',

  /**
   * æ¥è¯¢æ¡ä»¶
   */
  SelectCondition = 'selectCondition',

  /**
   * å±ç¤ºæ¡ä»¶
   */
  ShowCondition = 'showCondition'
}

export function getOriginPropertyName(propertyName: string) {
  return `origin-${propertyName}`;
}
